import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-checklist",
  "use": "icon-checklist-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checklist\"><g><path d=\"m375.01 66.5v-31.167h-60.353c-11.329-21.509-33.706-35.333-58.657-35.333s-47.328 13.824-58.657 35.333h-60.353v31.167h-76.99v445.5h392v-445.5zm-208.02-1.167h51.101l3.386-10.327c4.904-14.957 18.777-25.006 34.523-25.006s29.619 10.049 34.523 25.006l3.386 10.327h51.101v37h-178.02zm255.01 416.667h-332v-385.5h46.99v35.833h238.02v-35.833h46.99z\" /><path d=\"m241.335 323.799-31.518-31.163-21.092 21.332 51.816 51.233 82.317-75.369-20.258-22.127z\" /><path d=\"m256 185.623c-69.317 0-125.71 56.394-125.71 125.71s56.393 125.71 125.71 125.71 125.71-56.394 125.71-125.71-56.393-125.71-125.71-125.71zm0 221.42c-52.775 0-95.71-42.936-95.71-95.71s42.935-95.71 95.71-95.71 95.71 42.936 95.71 95.71-42.935 95.71-95.71 95.71z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/checklist.svg
// module id = FCiH
// module chunks = 102